import { VariantColor } from '@repo/toolkit/colors'
import { valueRender } from '@repo/toolkit/conditional-render'
import { DateFormatter } from '@repo/toolkit/date'
import Badge from '@repo/ui/badge'

import { Time } from '../../lib/types/utils'

interface TimeBadgeProps {
  time: Time | string
  variant?: VariantColor
}

const TimeBadge = ({ time, variant = 'grey' }: TimeBadgeProps) => (
  <Badge
    text={valueRender(time, (time) =>
      typeof time === 'string' ? time : DateFormatter.getFormattedTime(time)
    )}
    variant={variant}
  />
)

export default TimeBadge
